import React, { useState, useEffect } from 'react';
import Header from '../../Components/Header';
import Seo from '../../Components/SeoComponent/Seo';
import Loader from '../../Loader';
import InputFloatLabel from '../../Components/ConfirmPopUp/InputFloatLabel';
import SelectFloatLabel from '../../Components/ConfirmPopUp/SelectFloatLabel';
import { Button } from '../../Components/Tags/Tags';
import PaginationData from '../../Components/PaginationData';
import { PayoutListReport } from '../../Services/PayoutService.js/Payouts';
import { showErrorToast, showSuccessToast } from '../../utils/toastUtils';
import moment from 'moment';
import DataModal from '../../Components/ConfirmPopUp/DataModal';
import html2pdf from 'html2pdf.js';
import { IoMdDownload } from "react-icons/io";
import { fetchProfile } from '../../Services/profile/profileservice';

const PayoutAllReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterData, setFilterData] = useState({
    account_number: '',
    beneficiary_name: '',
    amount: '',
    from_date: '',
    to_date: '',
    payment_type: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [payoutReportData, setPayoutReportData] = useState([]);
   const [profileData, setProfileData] = useState([]);
     const [payoutAccount, setPayoutAccount] = useState('');

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };



  const handleFetchData = async (page = 1, isUserTriggered = false) => {
    try {
      setIsLoading(true);

      // Clean filterData
      const cleanedFilters = Object.entries({
        total_data: 10,
        ...filterData,
        txn_type: filterData.payment_type
      }).reduce((acc, [key, val]) => {
        if (val !== '' && val !== null && val !== undefined) {
          acc[key] = val;
        }
        return acc;
      }, {});

      const response = await PayoutListReport(page, cleanedFilters);

      const serverErrorCode = response?.status?.code;
      const serverErrorMsg = response?.status?.message || response?.message;

      if (serverErrorCode && serverErrorCode !== 200) {
        setPayoutReportData([]);
        setPaginationData(null);
        showErrorToast(serverErrorMsg || 'Server returned an error');
        return;
      }
      setPayoutReportData(response.data || response.data.data || []);
      setPaginationData(response?.pagination || null);
      setCurrentPage(response.pagination.current_page || 1);
      setLastPage(response.pagination.last_page || 1);
      if (isUserTriggered) {
        showSuccessToast(response.message || 'Report loaded successfully');
      }

    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        'Something went wrong while fetching payout report.';
      showErrorToast(errorMsg);
      console.error("Error fetching payout report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Optional: auto-fetch on mount
  useEffect(() => {
    handleFetchData(currentPage);
  }, [currentPage]);

  function handlePage(page) {
    setCurrentPage(page);
  }


  const handleDownload = () => {
    const element = document.getElementById('txn-report-card');

    const opt = {
      margin: 0,
      filename: `txn_${selectedReport.transaction_id || 'report'}.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: {
        scale: 3,
        useCORS: true
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait'
      }
    };

    html2pdf().set(opt).from(element).save();
  };



    useEffect(() => {
      async function fetchProfileData() {
        try {
          const response = await fetchProfile();
          setProfileData(response.data);
        } catch (error) {
          showErrorToast('Error fetching profile data', error);
        }
      }
      fetchProfileData();
    }, []);


    useEffect(() => {
      if (profileData?.payout_account?.account_number) {
        setPayoutAccount(profileData.payout_account.account_number);
      }
    }, [profileData]);
    
  

  return (


    <div className="p-4">
      {isLoading && <Loader />}

      <DataModal visible={isOpen} onClose={() => setIsOpen(false)} className="!p-0">
        <div className="w-full max-w-7xl p-1 sm:p-6 md:p-2 relative bg-white rounded-lg shadow-lg">
          <div className="bg-white rounded-xl shadow-lg p-1 space-y-2 border" id="txn-report-card">
            <h2 className="text-blue-800 font-bold text-2xl border-b text-center">Report</h2>
            {selectedReport ? (
              <>
                <div className="bg-blue-50 rounded-md p-2 shadow-inner">
                  <h3 className="text-blue-700 font-semibold text-lg mb-1">Transaction Details</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm">
                    <div>
                      <span className="text-gray-500 font-semibold">Transaction ID:</span>
                      <p>{selectedReport.transaction_id}</p>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">Reference ID:</span>
                      <p>{selectedReport.payout_reference?.reference_id || '-'}</p>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">Status:</span>
                      <span
                        className=
                        "inline-block px-1 py-1 ms-1 rounded-xl text-black font-semibold text-sm"
                         >
                        {selectedReport.status?.value || '-'}
                      </span>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">Date:</span>
                      <p>{moment(selectedReport.created_at).format('DD/MM/YYYY hh:mm A')}</p>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">Amount:</span>
                      <p>₹{selectedReport.amount}</p>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">Factor:</span>
                      <p>{selectedReport.factor}</p>
                    </div>
                  </div>
                </div>

                {/* 🔹 Beneficiary Card */}
                <div className="bg-green-50 rounded-md p-1 shadow-inner">
                  <h3 className="text-green-700 font-semibold text-lg mb-1">Beneficiary Details</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm">
                    <div>
                      <span className="text-gray-500 font-semibold">Name:</span>
                      <p>{selectedReport.beneficiary_name || '-'}</p>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">Address:</span>
                      <p>{selectedReport.beneficiary_address || '-'}</p>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">Account Number:</span>
                      <p>{selectedReport.credit_account_number}</p>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">IFSC Code:</span>
                      <p>{selectedReport.ifsc_code}</p>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">Mode:</span>
                      <p>{selectedReport.payout_mode?.name}</p>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">Method:</span>
                      <p>{selectedReport.payout_method?.name}</p>
                    </div>
                  </div>
                </div>

                {/* 🔹 Initiator Info Card */}
                <div className="bg-yellow-50 rounded-md p-1 shadow-inner">
                  <h3 className="text-yellow-700 font-semibold text-lg mb-1">Initiator Info</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                    <div>
                      <span className="text-gray-500 font-semibold">Email:</span>
                      <p>{selectedReport.email}</p>
                    </div>
                    <div>
                      <span className="text-gray-500 font-semibold">Phone:</span>
                      <p>{selectedReport.phone}</p>
                    </div>
                  </div>
                </div>

                {/* 🔹 Failure Message (if any) */}
                {selectedReport.failure_message && (
                  <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-1 rounded">
                    <p><strong>Failure Message:</strong> {selectedReport.failure_message}</p>
                  </div>
                )}

                <div className="bg-gray-100 rounded-md p-1 shadow-inner text-xs text-gray-800 break-words">
                  <h3 className="text-gray-700 font-semibold mb-2">Transaction Response</h3>
                  <div className="space-y-1 text-sm">
                    {(() => {
                      try {
                        const parsed = JSON.parse(selectedReport.transaction_response);
                        const meta = parsed?.initiateAuthGenericFundTransferAPIResp?.metaData;
                        return meta ? (
                          <>
                            <div>
                              <span className="font-semibold text-gray-600">Status:</span>{' '}
                              <span className="text-gray-800">{meta.status || '-'}</span>
                            </div>
                            <div>
                              <span className="font-semibold text-gray-600">Message:</span>{' '}
                              <span className="text-gray-800">{meta.message || '-'}</span>
                            </div>

                          </>
                        ) : (
                          <p className="text-gray-500 italic">Meta data not available</p>
                        );
                      } catch (e) {
                        return <pre className="text-gray-600">{selectedReport.transaction_response}</pre>;
                      }
                    })()}
                  </div>

                </div>

              </>
            ) : (
              <p className="text-center text-gray-500">No Data Found</p>
            )}
          </div>

          <div className='flex justify-center gap-2 mt-2'>

            {/* Download Button */}
            <button
              onClick={handleDownload}
              className=" right-2 bg-blue-600 hover:bg-blue-800 text-white text-sm p-1 rounded-md shadow-md"
            >
              <IoMdDownload size={16} className='inline' /> Download
            </button>
            {/* Close Button */}
            <button
              onClick={() => setIsOpen(false)}
              className="left-2 bg-red-500 hover:bg-red-700 text-white text-xs font-semibold px-3 py-1 rounded-md shadow"
            >
              ✕ Close
            </button>
          </div>
        </div>
      </DataModal>


      <Header heading="Payout Report" />
      <Seo title="Payout Report" />


      {/* Filter Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 bg-white shadow-md p-4 rounded-md mb-4">
        <InputFloatLabel
          name="account_number"
          type="text"
          labelText="Account Number"
          value={filterData.account_number}
          onChange={handleChange}
        />
        <InputFloatLabel
          name="beneficiary_name"
          type="text"
          labelText="Beneficiary Name"
          value={filterData.beneficiary_name}
          onChange={handleChange}
        />
        <InputFloatLabel
          name="amount"
          type="text"
          labelText="Amount"
          value={filterData.amount}
          onChange={handleChange}
        />
        <InputFloatLabel
          name="from_date"
          type="date"
          labelText="Transaction from Date"
          value={filterData.from_date}
          onChange={handleChange}
        />
        <InputFloatLabel
          name="to_date"
          type="date"
          labelText="Transaction To Date"
          value={filterData.to_date}
          onChange={handleChange}
        />
        <SelectFloatLabel
          name="payment_type"
          type="select"
          labelText="Payment Type"
          value={filterData.payment_type}
          onChange={handleChange}
        >
          <option value="" disabled>Select Payment Type</option>
          <option value="NEFT">NEFT</option>
          <option value="IMPS">IMPS</option>
        </SelectFloatLabel>

        <div className="flex items-end">
          <Button
            type="button"
            text="Submit"
            className="bg-blue-800 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-900 w-1/2"
            onClick={() => handleFetchData(1, true)}
          />
        </div>
      </div>



      {/* Table Section */}
      <div className="overflow-x-auto mt-4 hidden md:block">
        <table className="min-w-full divide-y divide-gray-200 ">
          <thead className="bg-blue-800 text-white">
            <tr className='font-mono '>
              <th className="p-1 border">SN.</th>
              <th className="p-1 border">Status</th>
              <th className="p-1 border">Order ID</th>
              <th className="p-1 border">From A/C</th>
              <th className="p-1 border">To A/C</th>
              <th className="p-1 border">Beneficiary</th>
              <th className="p-1 border">RRN/UTR</th>
              <th className="p-1 border">Date</th>
              <th className="p-1 border">Type</th>
              <th className="p-1 border">Mode</th>
              <th className="p-1 border">Amount</th>
              <th className="p-1 border">Action</th>
            </tr>
          </thead>
          <tbody>
            {payoutReportData.length > 0 ? (
              payoutReportData.map((item, idx) => (
                <tr key={idx} className="border hover:bg-blue-50 text-center">
                  <td className="p-1 border  shadow-inner shadow-blue-600 font-bold">{(currentPage - 1) * 10 + idx + 1}</td>
                  <td className="p-1 border shadow-inner shadow-blue-400 text-center">
                    <button
                      className={`w-full px-0 py-1 text-white font-medium text-sm rounded-full cursor-default 
                        ${item?.status.value === 'success'
                          ? 'bg-green-500'
                          : item?.status.value === 'pending'
                            ? 'bg-yellow-500'
                            : 'bg-red-500'
                        }`}
                      disabled
                    >
                      {item?.status.value || '-'}
                    </button>
                  </td>

                  <td className="p-1 border shadow-inner shadow-blue-400">{item?.transaction_id || '-'}</td>
                  <td className="p-1 border shadow-inner shadow-blue-400">{payoutAccount || '-'}</td>
                  <td className="p-1 border shadow-inner shadow-blue-400">{item?.credit_account_number || '-'}</td>
                  <td className="p-1 border shadow-inner shadow-blue-400">{item?.beneficiary_name || '-'}</td>
                  <td className="p-1 border shadow-inner shadow-blue-400">{item?.utr || '-'}</td>
                  <td className="p-1 border text-xs shadow-inner shadow-blue-400">{moment(item?.created_at).format('DD/MM/YYYY h:mmA')}</td>
                  <td className="p-1 border shadow-inner shadow-blue-400">{item?.payout_method.name || '-'}</td>
                  <td className="p-1 border shadow-inner shadow-blue-400">{item.payout_mode.name || '-'}</td>
                  <td className="p-1 border shadow-inner shadow-blue-400">₹{item.amount || '-'}</td>
                  <td className="p-1 border shadow-inner shadow-blue-400">
                    <Button
                      type="button"
                      text="View"
                      onClick={() => {
                        setSelectedReport(item); // set the current item in state
                        setIsOpen(true);         // open the modal
                      }}
                      className="text-xs bg-green-600 text-white px-1 py-0.5 rounded hover:bg-blue-900"
                    />

                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={12} className="text-center text-gray-500 py-4">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <PaginationData currentPage={currentPage} lastPage={lastPage} handlePage={handlePage} />
    </div>
  );
};

export default PayoutAllReport;
